import { render, staticRenderFns } from "./GradesEmptyState.vue?vue&type=template&id=13c193e0&scoped=true&"
import script from "./GradesEmptyState.vue?vue&type=script&lang=js&"
export * from "./GradesEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./GradesEmptyState.vue?vue&type=style&index=0&id=13c193e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c193e0",
  null
  
)

export default component.exports